import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';

const StyledRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '&.row-center': { justifyContent: 'center' },
  '&.row-dont-center': { alignItems: 'flex-start' },
  '&.row-full-width': { width: '100%' },
  '&.row-full-height': { flex: 1, height: '100%' },
  '&.row-right': { justifyContent: 'right' },
  '&.row-space-between': { justifyContent: 'space-between' },
  '&.row-wrap': { flexWrap: 'wrap' },
});

const StyledColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  '&.row-center': { alignItems: 'center', justifyContent: 'center' },
  '&.row-full-width': { width: '100%' },
  '&.row-full-height': { flex: 1, height: '100%' },
});

export const Row = ({ className, center, dontCenter, fullWidth, fullHeight, right, spaceBetween, wrap, ...props }) => {
  return (
    <StyledRow
      className={clsx(
        center && 'row-center',
        dontCenter && 'row-dont-center',
        fullWidth && 'row-full-width',
        fullHeight && 'row-full-height',
        right && 'row-right',
        spaceBetween && 'row-space-between',
        wrap && 'row-wrap',
        className
      )}
      {...props}
    />
  );
};

export const Column = ({ className, center, fullWidth, fullHeight, ...props }) => {
  return (
    <StyledColumn
      className={clsx(center && 'row-center', fullWidth && 'row-full-width', fullHeight && 'row-full-height', className)}
      {...props}
    />
  );
};
